'use client'

import { useTranslations } from 'next-intl'
import ConfirmationDialog from './confirmation-dialog'

type PropsType = {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
  isDeleting?: boolean
  title?: string
  description?: string
}

const DeleteConfirmationDialog = ({ open, onCancel, onConfirm, isDeleting = false, title, description }: PropsType) => {
  const t = useTranslations()

  return (
    <ConfirmationDialog
      open={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
      isLoading={isDeleting}
      title={title}
      description={description || t('delete_confirmation_message')}
      loadingText={t('deleting')}
      variant="destructive"
    />
  )
}

export default DeleteConfirmationDialog
